module.exports = __webpack_public_path__ + "static/media/liveschedulebanner.21770aea.png";